import { render } from "./teamSection.vue?vue&type=template&id=64d90cc7"
import script from "./teamSection.vue?vue&type=script&lang=js"
export * from "./teamSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__